// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1zS3G","m-signature-pad--body":"styles__m-signature-pad--body___3etuf","m-signature-pad--footer":"styles__m-signature-pad--footer___1HwXP","description":"styles__description___1fwaB","button":"styles__button___C1u82","clear":"styles__clear___n_zjB","save":"styles__save___h9IwK","m-signature-pad":"styles__m-signature-pad___38O81","github":"styles__github___2Gxkh","updatesList":"styles__updatesList___264i6","nestedAttribute":"styles__nestedAttribute___4DMGK"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/styles.scss
// module id = diHI
// module chunks = client